var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ 'verified-animate': _vm.showPendingVerification },attrs:{"src":require("@/assets/images/user/shield.svg"),"alt":"Verified"}})}
var staticRenderFns = []

export { render, staticRenderFns }